// Стек in-app тостов (SPEC §4.5). Рендерит очередь NotificationsContext: тап по message-тосту ведёт в
// чат (action), у update-тоста — кнопка действия. Презентация на токенах темы; данные — из контекста.

import type { CSSProperties } from 'react'
import { Button } from '@tele-chat/design-system'
import { useNotifications } from '../notifications/NotificationsContext.js'

export function ToastStack(): JSX.Element {
  const { toasts, dismiss } = useNotifications()

  const wrap: CSSProperties = {
    position: 'fixed',
    top: 'var(--space-4)',
    right: 'var(--space-4)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-2)',
    zIndex: 'var(--z-sheet)' as unknown as number,
    maxWidth: '360px',
  }

  return (
    <div data-toast-stack="" style={wrap}>
      {toasts.map((t) => {
        const card: CSSProperties = {
          background: 'var(--color-surface)',
          color: 'var(--color-text)',
          borderRadius: 'var(--radius-card)',
          boxShadow: 'var(--shadow-menu)',
          padding: 'var(--space-3)',
          borderLeft: `3px solid ${t.kind === 'error' ? 'var(--color-danger)' : 'var(--color-accent)'}`,
          cursor: t.action ? 'pointer' : 'default',
          minWidth: 0,
        }
        return (
          <div
            key={t.id}
            data-toast={t.kind}
            role="status"
            style={card}
            onClick={() => {
              if (t.action) {
                t.action.run()
                dismiss(t.id)
              }
            }}
          >
            <div
              style={{
                fontWeight: 'var(--weight-semibold)',
                fontSize: 'var(--font-md)',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {t.title}
            </div>
            {t.body ? (
              <div
                data-toast-body=""
                style={{
                  fontSize: 'var(--font-sm)',
                  color: 'var(--color-text-muted)',
                  marginTop: '2px',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {t.body}
              </div>
            ) : null}
            {t.kind === 'update' && t.action ? (
              <div style={{ marginTop: 'var(--space-2)' }}>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation()
                    t.action?.run()
                    dismiss(t.id)
                  }}
                >
                  {t.action.label}
                </Button>
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
